export default __webpack_public_path__ + "static/media/instagram.f1801586.svg";